import React from 'react';
import { Col, Row, Spinner } from 'reactstrap';

const Loader = ({ type = 'grow', size = 'lg', color = 'primary', ...rest }) => {
  const props = { type, size, color, ...rest };
  return (
<Row className={`flex-center ${props.padding ? 'py-5' : 'py-2'}`}>
  <Col xs="auto">
    <Spinner {...props} />
  </Col>
</Row>
  );
};

Loader.propTypes = { ...Spinner.propTypes };

export default Loader;